export default "__VITE_ASSET__BTE072hI__"